import { memo, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

import CuminButton from '@components/Button';
import Controls from '@components/Controls';
import InputError from '@components/InputError';
import Messaging from '@public/assets/svg/Messaging.svg';

import { useStyles } from '../useStyles';

interface ISendSmsSection {
  mobileNumber: string;
  mobileNumberErr: string;
  handleInputMobileChange: (e: any) => void;
  onClickErrorCloseIcon: () => void;
  onClickGetDiscount: () => void;
  setStep: (step: number) => void;
}

const SendSmsSection = ({
  mobileNumber,
  mobileNumberErr,
  handleInputMobileChange,
  onClickErrorCloseIcon,
  onClickGetDiscount,
  setStep,
}: ISendSmsSection) => {
  const classes = useStyles();

  //to  sen sms on hit of Enter from keyboard
  useEffect(() => {
    const listener = (event: any) => {
      if (event.code === 'Enter') {
        onClickGetDiscount();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [onClickGetDiscount]);

  return (
    <Box className={classes.rightContainer}>
      <Box className={classes.wrapper}>
        <Box className={classes.wrapper}>
          <Box className={classes.dTDisplayNone}>
            <Messaging />
          </Box>
          <Typography
            variant="body2"
            align="center"
            color="garamMasala.main"
            m="30px 0"
          >
            We can text you updates, exclusive deals, and special offers!
          </Typography>
          <Box sx={{ position: 'relative' }}>
            <Controls.MobileInputField
              name="phone_number"
              placeholder="Phone Number"
              value={mobileNumber}
              onChange={handleInputMobileChange}
              autoComplete="tel-national"
            />
            <InputError
              error={mobileNumberErr}
              className={classes.emailError}
              onClickErrorCloseIcon={onClickErrorCloseIcon}
            />
          </Box>
          <CuminButton
            color="cinnamon"
            variant="contained"
            textColor="whitePepper.main"
            width="240px"
            height="48"
            borderRadius="24"
            className={classes.discountBtn}
            onClick={onClickGetDiscount}
          >
            Send me SMS
          </CuminButton>
          <Typography
            variant="body2"
            color="cinnamon.main"
            className={classes.noThanksText}
            onClick={() => setStep(3)}
          >
            No thanks, I don’t want to be a VIP
          </Typography>
          <Typography variant="caption" align="center" color="cumin.main">
            By submitting this form, you agree to receive marketing text
            messages from us at the number provided. Consent is not a condition
            of purchase. View our Privacy Policy and Terms of Service.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default memo(SendSmsSection);
